import React, { useState } from "react";

import { tallaEnNombre, TallaEnNombre } from "../../../../utils/tallaEnNombre";

/**
	Aviso bajo el nombre cuando trae la talla ("Bata de Belleza S"): con la talla en el nombre cada talla queda como un producto
	aparte. Solo avisa; "Así Está Bien" lo calla para ese nombre.
*/
const AvisoTalla: React.FC<{ name: string; busy?: boolean; onFix: (found: TallaEnNombre) => void }> = ({ name, busy, onFix }) => {
	const [ignored, setIgnored] = useState<string | null>(null);
	const found = tallaEnNombre(name);
	if (!found || ignored === name.trim()) return null;
	return <div style={{ border: "1px solid var(--wa-oro)", background: "var(--wa-oro-suave)", borderRadius: "8px", padding: "8px 10px", fontSize: "13px" }}>
		<div style={{ color: "var(--wa-oro)", fontWeight: 600 }}>La talla va aparte, no en el nombre.</div>
		<div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "6px" }}>
			<button type="button" className="btn btn-primary btn-sm rounded-pill" disabled={busy} onClick={() => onFix(found)}>Quitar «{found.size}» del Nombre</button>
			<button type="button" className="btn btn-outline-secondary btn-sm rounded-pill" disabled={busy} onClick={() => setIgnored(name.trim())}>Así Está Bien</button>
		</div>
	</div>;
};

export default AvisoTalla;
